import React from 'react'

import Comment from './Comment'
import CompanyContribution from './CompanyContribution'
import Tribute from './Tribute'

// Optional-metadata block for the donation: company contribution,
// tribute, comment. Rendered between the Contact form and the action
// button (Continue on ContactStep; the wallet button on
// ExpressCheckout). Each subsection has its own enable / disable
// state inside `extras` (see useDonationExtras at App level).
//
// DataSharing used to live here too but is now a sibling component —
// it's conceptually privacy-consent (not "optional metadata") and
// has its own constraints (e.g. doesn't apply to stock/DAF). The
// caller renders <DataSharing /> + <DonationExtras /> together,
// usually wrapped in `space-y-2` so the two surfaces share consistent
// vertical rhythm.
const DonationExtras = ({
  extras, i18n,
  // Comment-modal config (threaded down to the Comment portal mount).
  blank_modal_src, emoji_picker_loader_src, widget_instance_token,
}) => (
  <div className="space-y-2">
    <CompanyContribution
      i18n={i18n}
      companyContribution={extras.companyContribution}
      blank_modal_src={blank_modal_src}
      widget_instance_token={widget_instance_token}
    />
    <Tribute
      i18n={i18n}
      tribute={extras.tribute}
      blank_modal_src={blank_modal_src}
      widget_instance_token={widget_instance_token}
    />
    {extras.comment.enabled && (
      <Comment
        i18n={i18n}
        value={extras.comment.value}
        submitted={extras.comment.submitted}
        onSave={extras.comment.save}
        onRemove={extras.comment.remove}
        blank_modal_src={blank_modal_src}
        emoji_picker_loader_src={emoji_picker_loader_src}
        widget_instance_token={widget_instance_token}
      />
    )}
  </div>
)

export default DonationExtras
